import { render } from "./manual-enrollment.vue?vue&type=template&id=c79dada4&lang=pug"
import script from "./manual-enrollment.vue?vue&type=script&setup=true&lang=js"
export * from "./manual-enrollment.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__